import React, { Suspense } from 'react';

const App = React.lazy(() => import('./App'));
const PublicStatsPage = React.lazy(() => import('./Components/Stats/PublicStatsPage'));

class EntryBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    return this.state.failed ? (
      <>
        <p role='alert'>No se pudo cargar la vista interactiva. / Could not load the interactive view.{' '}
          <button onClick={() => window.location.reload()}>Reintentar / Retry</button>
        </p>
        {this.props.fallback}
      </>
    ) : this.props.children;
  }
}

export default function RouteEntry({ statsPage, staticHtml = '' }) {
  // Preserve the readable server document during chunk loading and on failure.
  const fallback = staticHtml
    ? <div dangerouslySetInnerHTML={{ __html: staticHtml }} />
    : <p role='status'>Cargando… / Loading…</p>;
  return (
    <EntryBoundary fallback={fallback}>
      <Suspense fallback={fallback}>
        {statsPage ? <PublicStatsPage page={statsPage} /> : <App />}
      </Suspense>
    </EntryBoundary>
  );
}